// extracted by mini-css-extract-plugin
var _1 = "ChatFormFields-moduleactions__fe0ol FormActions-moduleFormActions__WNNEs";
var _2 = "ChatFormFields-moduleformFields__cHIOo FormFieldsContainer-moduleFormFieldsContainer__u1JJu";
export { _1 as "actions", _2 as "formFields" }
